import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c7b17b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chartdiv",
  ref: "chart",
  style: {"width":"100%","height":"500px"}
}

import { ref, onMounted, watch } from "vue";
import { Parameter } from "@/types/parameter.type";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5lang_es_ES from "@amcharts/amcharts5/locales/es_ES";
import { useRoute } from "vue-router";
import { getParameter } from "@/service/parameter.service";
import { Filter } from "@/types/filter.type";
import { getPaginatedEstimations, getAverageEstimations } from "@/service/estimation.service";
import { Estimation, ValidationFilter_2 } from "@/types/estimation.type";


export default /*#__PURE__*/_defineComponent({
  props: {
    dataClient: null,
    parameterImport: null,
    csvContent: null,
    selectedValue: null,
    selectedTimeFrom: null,
    selectedTimeTo: null,
    nameParameter: null
  },
  setup(__props: any) {

const props = __props as {
  dataClient: Array<{ date: string; value: string }>;
  parameterImport: Parameter;
  csvContent: string;
  selectedValue: string;
  selectedTimeFrom: string;
  selectedTimeTo: string;
  nameParameter: string;
}

const route = useRoute();
const tableData = ref([] as Array<{ date: string; value: string }>);
const parameterName = ref("");
const startDate = ref("");
const endDate = ref("");
let parameter = [] as Parameter[];



const processCsvData = async (csvContent: string) => {
  const rows = csvContent.split("\n").map((row: string) => row.split(";"));

  const availableParameters = rows[0].slice(1);
  if (!props.nameParameter && availableParameters.length > 0) {
    parameterName.value = availableParameters[0];
  } else {
    parameterName.value = props.nameParameter;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filteredRows = rows.slice(1).filter((row: any[]) => row[0].trim() && row[1].trim());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dates = filteredRows.map((row: any[]) => row[0]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tableData.value = filteredRows.map((row: any[]) => ({
    date: row[0].trim(),
    value: row[1].replace("\r", "").replace(",", ".").trim(),
  }));
  startDate.value = dates[0];
  endDate.value = dates[dates.length - 1];
};

const parseDate = (dateString: string) => {
  const [day, month, year, ...time] = dateString.split(/[/ :]/);
  if (time.length === 0) {
    return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
  } else {
    const [hour, minute, second = 0] = time.map(Number);
    return new Date(Number(year), Number(month) - 1, Number(day), hour, minute, second).getTime();
  }
};

function formatTime(dateString: string): string {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "00:00";
  }

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
}

//Crear la gráfica
const createChart = async (data: Array<{ date: string; value: string }>) => {
  //Obtener id parametro
  const filter: Filter = {
    fields: {
      "parameter.name": {
        operator: "equal",
        value: props.nameParameter.replace("\r", ""),
      },
    },
  };
  parameter = (await getParameter(undefined, undefined, filter))?.data;

  async function getDataChart() {
    //Obtener id parametro
    let filter: Filter = {
      fields: {
        "parameter.name": {
          operator: "equal",
          value: props.nameParameter.replace("\r", ""),
        },
      },
    };

    parameter = (await getParameter(undefined, undefined, filter))?.data;

    //Obtener estimaciones
    const validationFilter = {
      samplingPointId: Number(route.params.samplingPoint),
      parameterId: Number(parameter[0].id),
      date: [new Date(parseDate(startDate.value)), new Date(parseDate(endDate.value))],
    } as unknown as ValidationFilter_2;

    let estimation_history = await getPaginatedEstimations(validationFilter);
    if (props.selectedValue == "Muestras integradas") {
      estimation_history = await getAverageEstimations(
        validationFilter,
        formatTime(props.selectedTimeFrom),
        formatTime(props.selectedTimeTo)
      );
    }

    return estimation_history.map((estimation: Estimation) => ({
      date: estimation.dateTime ? new Date(estimation.dateTime).getTime() : undefined,
      value: estimation.value,
      // value: numberFormatter(estimation.value),
    }));
  }

  am5.array.each(am5.registry.rootElements, (root: am5.Root) => {
    if (root != undefined) {
      if (root.dom.id === "chartdiv") {
        root.dispose();
      }
    }
  });

  //Gráfica
  const root = am5.Root.new("chartdiv");
  root.locale = am5lang_es_ES;

  root.setThemes([am5themes_Animated.new(root)]);

  const chart = root.container.children.push(
    am5xy.XYChart.new(root, {
      panX: false,
      panY: false,
      wheelX: "panX",
      wheelY: "zoomX",
    })
  );

  const cursor = chart.set(
    "cursor",
    am5xy.XYCursor.new(root, {
      behavior: "zoomX",
    })
  );
  cursor.lineY.set("visible", false);
  cursor.lineX.set("visible", true);

  let xAxis = chart.xAxes.push(
    am5xy.DateAxis.new(root, {
      baseInterval: { timeUnit: "minute", count: 1 },
      renderer: am5xy.AxisRendererX.new(root, {}),
      tooltip: am5.Tooltip.new(root, {}),
      tooltipDateFormat: "dd/MM/yyyy HH:mm",
    })
  );

  if (props.selectedValue == "Muestras integradas") {
    xAxis = chart.xAxes.push(
      am5xy.DateAxis.new(root, {
        baseInterval: { timeUnit: "minute", count: 1 },
        renderer: am5xy.AxisRendererX.new(root, {}),
        tooltip: am5.Tooltip.new(root, {}),
        tooltipDateFormat: "dd/MM/yyyy",
      })
    );
  }

  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {}),
      // numberFormatter: am5.NumberFormatter.new(root, {
      //   numberFormat: "#,###.##",
      // }),
    })
  );

  const series1 = chart.series.push(
    am5xy.LineSeries.new(root, {
      name: "Estimaciones de Aquacorp",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      valueXField: "date",
      legendValueText: "{valueY}",
      tooltip: am5.Tooltip.new(root, {
        labelHTML:
          `<center><b>${props.nameParameter} <b/><center/>` +
          "{valueY.formatNumber('#,###.##')} " +
          ` ${parameter[0]?.unit ?? ""}`,
      }),
    })
  );

  const dataForSeries1 = await getDataChart();
  series1.data.setAll(dataForSeries1);
  series1.bullets.push(function (root) {
    return am5.Bullet.new(root, {
      sprite: am5.Circle.new(root, {
        radius: 3,
        fill: am5.color("#00FF00"),
      }),
    });
  });
  series1.strokes.template.set("stroke", am5.color("#00FF00"));
  if (props.selectedValue == "Retornos" || props.selectedValue == "Vertidos") {
    yAxis.get("renderer").labels.template.setAll({
      fill: am5.color("#00DD00"),
    });
    yAxis.get("renderer").ticks.template.setAll({
      stroke: am5.color("#00DD00"),
    });
    yAxis.get("renderer").grid.template.setAll({
      stroke: am5.color("#00DD00"),
    });
  }
  if (props.nameParameter.replace("\r", "") !== "Retorno") {
    series1.appear();
  }
  let chartData = data.map((item) => ({
    date: parseDate(item.date),
    value: parseFloat(item.value),
  }));

  if (props.selectedValue == "Retornos" || props.selectedValue == "Vertidos") {
    let interpolatedData: Array<{ date: number; value: number }> = [];
    for (let i = 0; i < chartData.length - 1; i++) {
      const currentItem = chartData[i];
      const nextItem = chartData[i + 1];
      interpolatedData.push(currentItem);

      if (currentItem.value !== nextItem.value) {
        interpolatedData.push({ date: nextItem.date, value: currentItem.value });
      }
    }

    const lastItem = chartData[chartData.length - 1];
    interpolatedData.push(lastItem);

    chartData = interpolatedData;

    const yAxisLeft = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: 1.5,
        strictMinMax: true,
        maxPrecision: 0,
        renderer: am5xy.AxisRendererY.new(root, {
          opposite: true,
          inside: false,
        }),
        numberFormatter: am5.NumberFormatter.new(root, {
          numberFormat: "#",
        }),
      })
    );

    if (props.selectedValue === "Retornos") {
      const seriesRetornos = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: "Retornos",
          xAxis: xAxis,
          yAxis: yAxisLeft,
          valueYField: "value",
          valueXField: "date",
          tooltip: am5.Tooltip.new(root, {
            labelHTML:
              `<center><b>${props.nameParameter} <b/><center/>` +
              "{valueY.formatNumber('#,###.##')} " +
              ` ${parameter[0]?.unit ?? ""}`,
          }),
        })
      );
      seriesRetornos.data.setAll(chartData);

      seriesRetornos.bullets.push(function (root) {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: seriesRetornos.get("fill"),
          }),
        });
      });
      seriesRetornos.strokes.template.set("stroke", am5.color("#FF0000"));
      yAxisLeft.get("renderer").labels.template.setAll({
        fill: am5.color("#0000EE"),
      });
      yAxisLeft.get("renderer").ticks.template.setAll({
        stroke: am5.color("#0000EE"),
      });
      yAxisLeft.get("renderer").grid.template.setAll({
        stroke: am5.color("#0000EE"),
      });
    }
  }

  if (props.selectedValue !== "Retornos") {
    const series = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Medidas de referencia del laboratorio",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        valueXField: "date",
        tooltip: am5.Tooltip.new(root, {
          labelHTML:
            `<center><b>${props.nameParameter} <b/><center/>` +
            "{valueY.formatNumber('#,###.##')} " +
            ` ${parameter[0]?.unit ?? ""}`,
        }),
      })
    );

    series.data.setAll(chartData);
    series.bullets.push(function (root) {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          radius: 3,
          fill: series.get("fill"),
        }),
      });
    });
    series.appear(1000);
  }

  const legend = chart.children.push(
    am5.Legend.new(root, {
      name: props.nameParameter,
      centerX: am5.percent(50),
      x: am5.percent(50),
      y: am5.percent(100),
      layout: root.horizontalLayout,
    })
  );

  legend.data.setAll(chart.series.values);

  chart.set(
    "scrollbarX",
    am5xy.XYChartScrollbar.new(root, {
      orientation: "horizontal",
      height: 30,
    })
  );

  chart.set(
    "scrollbarY",
    am5xy.XYChartScrollbar.new(root, {
      orientation: "vertical",
      width: 30,
    })
  );

  chart.appear(1000, 100);
};

onMounted(async () => {
  processCsvData(props.csvContent);
  createChart(tableData.value);
  // createChart(props.dataClient);
});

watch(
  () => [props.dataClient, props.nameParameter],
  (newDataClient) => {
    if (newDataClient && newDataClient.length > 0) {
      createChart(tableData.value);
      // createChart(props.dataClient);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, null, 512)
  ]))
}
}

})